export default {
  title: 'Paiement',
  description: 'Toutes les transactions sont sécurisées et chiffrées',
  show_more_payment_methods: 'Afficher plus de moyens de paiement',
  express_checkout_divider: 'ou',
};
